import template from './footer.html';
import './footer.less';

class FooterController {
    constructor() {
        'ngInject';
    }

    $onInit() {
        this.currentYear = new Date().getFullYear();
    }

}

export const FooterComponent = {
    name: 'mmsFooter',
    component: {
        template: template,
        controller: FooterController,
        bindings: {},
    }
};


// WEBPACK FOOTER //
// ./src/app/common/footer/footer.component.js